/// <reference path="../components/common/utils.js" />
import { Link as RouterLink } from 'react-router-dom';
import { React, useEffect, useState } from 'react';

// @mui
import { styled, useTheme } from '@mui/material/styles';
import { Typography, Grid, Stack, Card, Container, Box, Paper, MobileStepper, Button } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import * as LocalStorage from 'local-storage';
import URLS from '../services/urls.service';
import AppCache from '../services/AppCache';
// hooks
// components
import Logo from '../components/Logo';
import Page from '../components/Page';
// sections
import { LoginForm } from '../sections/auth/login';
import Utils from '../components/Common/Utils';



// ----------------------------------------------------------------------

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);



const RootStyle = styled(Page)(({ theme }) => ({
    [theme.breakpoints.up('xs')]: {
        backgroundColor: '#bcaaa4',
        height: '100%',
    }
}));


const ContentStyle = styled('div')(({ theme }) => ({
    width: '100%',
    maxWidth: 460,
    margin: 'auto',
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(1, 1),
    [theme.breakpoints.up('sm')]: {
        width: 430,
    },
}));


// ----------------------------------------------------------------------

export default function Login() {

    const imageFolderPath = Utils.commonImagePath;
    const defaultImages = [
        {
            Id: 1,
            LoginImageNamePath: "/static/illustrations/loginPage1.png",
            fitType: "image",
            outerBoxStyle: {
                width: 808,
                borderRadius: "12px",
                bgcolor: "#F8D5D72E",
                margin: "10px",
                position: "relative",
            },
            imgStyle: {
                width: "100%",
                position: "absolute",
                objectFit: "contain",
                top: "60px",
            },
        },
        {
            Id: 2,
            LoginImageNamePath: "/static/illustrations/loginPage2.png",
            fitType: "outer",
            outerBoxStyle: {
                width: 808,
                borderRadius: "12px",
                bgcolor: "#F8D5D7",
                margin: "10px",
                position: "relative",
                padding: "35px",
            },
            imgStyle: {
                width: "100%",
                position: "absolute",
                objectFit: "contain",
                top: "20px",
            },
        },
    ];

    const [imagePath, setImagePath] = useState(defaultImages);
  
    const theme = useTheme();
    const [activeStep, setActiveStep] = useState(0);
    const maxSteps = imagePath.length;
    const [hide, setHide] = useState(false);
    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleStepChange = (step) => {
        setActiveStep(step);
    };

    // Clear previous local storage data. 
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        // Clear previous local storage data. 
        AppCache.ClearStorage();
        LocalStorage.clear();

        // APIUrl calls
        URLS.configFileURL().then((response) => {
            if (response.status === 200) {
                const config = JSON.parse(JSON.stringify(response.data));
                // AppCache.SetCurrentAPIURL(config.SmileServiceApiBaseUrl);
                AppCache.SetCurrentAPIURL(config);
                setLoading(false);
            }
            else {
                // Failure response
                alert("Api URL  Failed");
            }
        })
         URLS.changeImageURL().then((response) => {
             if (response.status === 200) {
                 const merged = response.data.map((img, i) => ({
                     ...defaultImages[i],
                     LoginImageNamePath: img.LoginImageNamePath,
                 }));
                 setImagePath(merged); // API images
                console.log("response.data Data", response.data)
            }
            else {
                // Failure response
                alert("Change Image Api URL  Failed");
            }
         })

    }, []);


    if (loading) { return <CircularProgress /> }

    return (
        <Page title="Login | tiketic">
            <Box sx={{ height: '100vh', overflow: "hidden", }}>
                <Stack direction={{ xs: "column", md: "row" }} sx={{ height: "100vh" }}>

                    {/* LEFT SIDE (40%) */}
                    {/* LEFT SIDE (40%) */}
                    <Box
                        sx={{
                            flex: "0 0 40%",
                            display: "flex",
                            flexDirection: "column",
                            position: "relative", // important for absolute footer
                            overflow: "hidden",
                        }}
                    >
                        {/* Logo */}
                        <Box sx={{ pl: 3, pt: 2 }}>
                            <Logo />
                        </Box>

                        {/* Centered Form */}
                        <Box
                            sx={{
                              
                                px: 12,
                                py: 8,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                overflow: "hidden",
                            }}
                        >
                            {loading ? <CircularProgress /> : <LoginForm />}
                        </Box>

                        {/* Fixed Footer */}
                        <Stack
                            direction="row"
                            alignItems="center"
                            sx={{
                                position: "absolute",   // stick to bottom
                                bottom: '5px',             // some spacing
                                left: '20px',
                            }}
                        >
                            <Box
                                component="img"
                                src="/static/illustrations/sapl.png"
                                sx={{ width: 37, height: 30, mr: 1 }}
                            />
                            <Typography sx={{ fontSize: "11px", color: "#A2A2A2" }}>
                                &copy;2023-Tiketic(2.0) Smile Automation Pvt.Ltd, Pune, India
                            </Typography>
                        </Stack>
                    </Box>


                    {/* RIGHT SIDE (60%) */}
                    <Box sx={imagePath[activeStep]?.outerBoxStyle}>
                        <AutoPlaySwipeableViews
                            axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                            index={activeStep}
                            onChangeIndex={handleStepChange}
                            enableMouseEvents
                            style={{ width: "100%", height: "100%", overflow: "hidden", }}

                        >
                            {imagePath.map((step, index) => (
                                <div key={step.Id}>
                                    {Math.abs(activeStep - index) <= 2 ? (
                                        <Box
                                            component="img"
                                            src={step.LoginImageNamePath}
                                            alt={step.Id}
                                            // sx={step.imgStyle}
                                            sx={{
                                                width: '100%',
                                                height: '100vh',        
                                                objectFit: 'contain',  // keeps aspect ratio
                                                display: 'block',
                                            }}
                                        />
                                    ) : null}
                                </div>
                            ))}
                        </AutoPlaySwipeableViews>

                        {/* Stepper */}
                        <MobileStepper
                            steps={imagePath.length}
                            position="static"
                            activeStep={activeStep}
                            sx={{
                                bgcolor: "transparent",
                                justifyContent: "center",
                                position: "absolute",
                                bottom: 8,
                                left: "50%",
                                transform: "translateX(-50%)",
                                width: "100%",
                            }}
                            backButton={null}
                            nextButton={null}
                        />
                    </Box>



                </Stack>
            </Box>
        </Page>

    );

}